<template>
  <div class="notification-log-row">
    <div class="name">{{ name }}</div>
    <div class="count">{{ notification_count }}</div>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  props: [
    "name",
    "notification_count"
  ],
  data() {
    return {};
  }
});
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.notification-log-row {
  display: grid;
  grid-gap: $space;
  grid-template-columns: auto auto;
  align-items: center;

  border-bottom: $border;
  padding: 15px 10px;

  font-size: 16px;

  > .count {
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/monitoring/modules/thirdPartyNotification/components/NotificationLogRow.vue